/* eslint-disable no-redeclare */
// $FlowFixMe workaround for: https://github.com/facebook/flow/issues/5838
var objectEntries = Object.entries || function (obj) {
  return Object.keys(obj).map(function (key) {
    return [key, obj[key]];
  });
};

export default objectEntries;



//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql/polyfills/objectEntries.mjs
// module id = 77
// module chunks = 0